const logoutLocally = () => {
    localStorage.removeItem('id_token');
    localStorage.removeItem('profile');
};

export default logoutLocally;
